var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3999 3.2001C5.07442 3.2001 3.9999 4.27461 3.9999 5.6001V8.8001C3.9999 11.0092 5.79076 12.8001 7.9999 12.8001C10.209 12.8001 11.9999 11.0092 11.9999 8.8001V5.6001C11.9999 5.15827 12.3581 4.8001 12.7999 4.8001C13.2417 4.8001 13.5999 5.15827 13.5999 5.6001V8.8001C13.5999 11.8929 11.0927 14.4001 7.9999 14.4001C4.90711 14.4001 2.3999 11.8929 2.3999 8.8001V5.6001C2.3999 3.39096 4.19076 1.6001 6.3999 1.6001C8.60904 1.6001 10.3999 3.39096 10.3999 5.6001V8.8001C10.3999 10.1256 9.32539 11.2001 7.9999 11.2001C6.67442 11.2001 5.5999 10.1256 5.5999 8.8001V5.6001C5.5999 5.15827 5.95807 4.8001 6.3999 4.8001C6.84173 4.8001 7.1999 5.15827 7.1999 5.6001V8.8001C7.1999 9.24192 7.55807 9.6001 7.9999 9.6001C8.44173 9.6001 8.7999 9.24192 8.7999 8.8001V5.6001C8.7999 4.27461 7.72539 3.2001 6.3999 3.2001Z",
    fill: "#B6B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg8);
export default __webpack_public_path__ + "static/media/svg8.8c0e76d189de6a05987ba920e53f7557.svg";
export { ForwardRef as ReactComponent };